/**
 * @import internal modules
 */
import * as Utils from '@root-utils/index';

/**
 * @import external modules
 */

import * as React from 'react';
import { pure } from 'recompose';
// import * as shortid from 'shortid';
// import * as cx from "classnames";

// component
const Component: React.FunctionComponent<any> = (
    props: InterfaceInfos<string>,
): JSX.Element => {
    const { onCloseItems, itemsModal } = props;
    const percentage =
        itemsModal && itemsModal.prod && itemsModal.prod.score_classif * 100;
    const percent = percentage && percentage.toFixed(1);

    return (
        <div className="modal" id="id_0" onClick={onCloseItems}>
            <div className="modale-insider ">
                <div className="modale-cart-items-real-times">
                    <div className="drag-close" onClick={onCloseItems} />

                    <div className="some-info-for-items">
                        <div className="images-items-rt left">
                            <div className="cart-items-cart">
                                <img
                                    src={
                                        itemsModal && itemsModal.prod.image_url
                                    }
                                    alt=""
                                />{' '}
                            </div>
                        </div>

                        <div className="some-infos left">
                            <div className="timestamp-items">
                                <div className="with-3-columns">
                                    <div className="items-stats-items">
                                        <div className="items-cart--stats">
                                            <span>
                                                <svg
                                                    width="20"
                                                    height="19"
                                                    viewBox="0 0 23 23"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M11.5 0C5.15844 0 0 5.15844 0 11.5C0 17.8416 5.15844 23 11.5 23C17.8416 23 23 17.8416 23 11.5C23 5.15844 17.8416 0 11.5 0ZM11.5 20.5391C6.5072 20.5391 2.46091 16.4691 2.46091 11.5C2.46091 6.53086 6.53086 2.46091 11.5 2.46091C16.4691 2.46091 20.5391 6.53086 20.5391 11.5C20.5391 16.4691 16.4928 20.5391 11.5 20.5391Z"
                                                        fill="white"
                                                    />
                                                    <path
                                                        d="M17.4865 11.145H12.3281V4.92172C12.3281 4.40115 11.9021 3.97522 11.3816 3.97522C10.861 3.97522 10.4351 4.40115 10.4351 4.92172V12.0915C10.4351 12.612 10.861 13.038 11.3816 13.038H17.4865C18.0071 13.038 18.433 12.612 18.433 12.0915C18.433 11.5709 18.0071 11.145 17.4865 11.145Z"
                                                        fill="white"
                                                    />
                                                </svg>
                                            </span>
                                            <span>
                                                {itemsModal &&
                                                    Utils.localDateFrSecondFormat(
                                                        itemsModal[
                                                            '@timestamp'
                                                        ],
                                                    )}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="items-stats-items">
                                        <div className="items-cart--stats">
                                            <span>
                                                <svg
                                                    width="20"
                                                    height="19"
                                                    viewBox="0 0 15 21"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M7.49798 0C3.36479 0 0 3.4125 0 7.6043C0 12.8092 6.70936 20.4504 6.9965 20.7703C7.26341 21.0738 7.73254 21.0738 7.99946 20.7703C8.2866 20.4463 14.996 12.8092 14.996 7.6043C15 3.4125 11.6352 0 7.49798 0ZM7.49798 11.4311C5.41925 11.4311 3.72472 9.7125 3.72472 7.6043C3.72472 5.49609 5.41925 3.77754 7.49798 3.77754C9.5767 3.77754 11.2712 5.49609 11.2712 7.6043C11.2712 9.7125 9.58075 11.4311 7.49798 11.4311Z"
                                                        fill="white"
                                                    />
                                                </svg>
                                            </span>
                                            <span>
                                                {itemsModal &&
                                                    itemsModal.stationName}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="timestamp-items">
                                <div className="with-3-columns">
                                    <div className="items-stats-items">
                                        <div className="items-cart--stats">
                                            <span>
                                                <svg
                                                    width="20"
                                                    height="19"
                                                    viewBox="0 0 25 19"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M23.9589 4.45449C23.8473 4.45449 23.7357 4.46693 23.6242 4.50426L22.3599 4.85265L21.0461 1.65488C20.6867 0.734119 19.5835 0 18.6044 0H6.35845C5.37928 0 4.28855 0.734119 3.91671 1.64244L2.60288 4.84021L1.36341 4.49181C1.25186 4.46693 1.14031 4.44204 1.02876 4.44204C0.433813 4.44204 0 4.90242 0 5.52456V6.27112C0 7.00524 0.594943 7.60249 1.32623 7.60249H1.47496L1.26425 8.12508C0.917204 8.97119 0.644522 10.3897 0.644522 11.3104V17.6686C0.644522 18.4028 1.23946 19 1.97075 19H3.706C4.43728 19 5.03223 18.4028 5.03223 17.6686V16.076H19.9554V17.6686C19.9554 18.4028 20.5503 19 21.2816 19H23.0169C23.7481 19 24.3431 18.4028 24.3431 17.6686V11.3104C24.3431 10.4021 24.058 8.97119 23.7234 8.12508L23.5126 7.60249H23.6738C24.4051 7.60249 25 7.00524 25 6.27112V5.52456C24.9876 4.90242 24.5538 4.45449 23.9589 4.45449ZM3.55726 6.89326L5.54041 2.05305C5.76351 1.50557 6.42043 1.07007 7.00297 1.07007H17.9598C18.5424 1.07007 19.1993 1.51801 19.4224 2.05305L21.4056 6.89326C21.6287 7.44073 21.3312 7.87623 20.7486 7.87623H4.21418C3.63163 7.87623 3.33416 7.44073 3.55726 6.89326ZM7.98215 13.0151C7.98215 13.3137 7.74665 13.5501 7.44918 13.5501H3.68121C3.38374 13.5501 3.14824 13.3137 3.14824 13.0151V11.2109C3.14824 10.9122 3.38374 10.6758 3.68121 10.6758H7.44918C7.74665 10.6758 7.98215 10.9122 7.98215 11.2109V13.0151ZM21.7774 13.0151C21.7774 13.3137 21.5419 13.5501 21.2444 13.5501H17.4764C17.179 13.5501 16.9435 13.3137 16.9435 13.0151V11.2109C16.9435 10.9122 17.179 10.6758 17.4764 10.6758H21.2444C21.5419 10.6758 21.7774 10.9122 21.7774 11.2109V13.0151Z"
                                                        fill="white"
                                                    />
                                                </svg>
                                            </span>
                                            <span>
                                                {itemsModal &&
                                                    itemsModal.prod
                                                        .pred_classif}{' '}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="items-stats-items">
                                        <div className="items-cart--stats">
                                            <span>
                                                <svg
                                                    width="20"
                                                    height="19"
                                                    viewBox="0 0 26 34"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M26 2.98828V0H0V2.98828C0 4.28984 0.833333 5.39219 2 5.80391V28.1961C0.833333 28.6078 0 29.7102 0 31.0117V34H26V31.0117C26 29.7102 25.1667 28.6078 24 28.1961V5.80391C25.1667 5.39219 26 4.28984 26 2.98828ZM20 28.0234V24.1852C20 21.8477 18.8333 19.6828 16.88 18.3812L14.8 17L16.88 15.6187C18.8333 14.3238 20 12.1523 20 9.81484V5.97656H22V28.0234H20ZM6 5.97656V9.81484C6 12.1523 7.16667 14.3172 9.12 15.6187L11.2 17L9.12 18.3812C7.16667 19.6762 6 21.8477 6 24.1852V28.0234H4V5.97656H6Z"
                                                        fill="white"
                                                    />
                                                </svg>
                                            </span>
                                            <span>
                                                {itemsModal &&
                                                    itemsModal.prod
                                                        .pred_time}{' '}
                                                ms
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="timestamp-items">
                                <div className="with-3-columns">
                                    <div className="items-stats-items">
                                        <div className="items-cart--stats">
                                            <span>
                                                <svg
                                                    width="20"
                                                    height="19"
                                                    viewBox="0 0 20 19"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M9.04894 0.927052C9.3483 0.00574112 10.6517 0.00573993 10.9511 0.927051L12.4697 5.60081C12.6035 6.01284 12.9875 6.2918 13.4207 6.2918H18.335C19.3037 6.2918 19.7065 7.53141 18.9228 8.10081L14.947 10.9894C14.5966 11.244 14.4499 11.6954 14.5838 12.1074L16.1024 16.7812C16.4017 17.7025 15.3472 18.4686 14.5635 17.8992L10.5878 15.0106C10.2373 14.756 9.7627 14.756 9.41221 15.0106L5.43648 17.8992C4.65276 18.4686 3.59828 17.7025 3.89763 16.7812L5.41623 12.1074C5.55011 11.6954 5.40345 11.244 5.05296 10.9894L1.07722 8.10081C0.293507 7.53141 0.696283 6.2918 1.66501 6.2918H6.57929C7.01252 6.2918 7.39647 6.01284 7.53035 5.60081L9.04894 0.927052Z"
                                                        fill="white"
                                                    />
                                                </svg>
                                            </span>
                                            <span>
                                                {itemsModal && percent} %
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// interface
export interface InterfaceInfos<T> {
    onCloseItems?: any;
    itemsModal?: any;
}
/**
 * DefaultProps values
 */
Component.defaultProps = {};

export default pure(Component);



// WEBPACK FOOTER //
// ./src/apps/components/@widgets/info-items/component.tsx